import type { ReactNode } from "react"

// A control with its label on the same line, for the section bars.
export default function Inline({ label, children }: { label: string; children: ReactNode }) {
  return (
    <div className="flex items-center gap-2">
      <span className="text-sm font-medium">{label}</span>
      {children}
    </div>
  )
}
